export default "__VITE_ASSET__fd2f254a__"